import CTA3 from './CTA3'
export default CTA3
